<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <DocumentsNewsBlockControl></DocumentsNewsBlockControl>
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">友情链接</div>
                  <div class="title_more2"><a href="">首页</a>>友情链接</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="xbjj_con">
                    <div class="pic_link" v-if="linkpic.length > 0">
                      <div class="advice_text">图片链接</div>
                      <el-row :gutter="25" class="row ten">
                        <el-col
                          class="linkpic text-center"
                          v-for="(item, index) in linkpic"
                          :key="index"
                          :xs="24"
                          :sm="24"
                          :md="12"
                          :lg="6"
                          :xl="6"
                          :title="item.Tips"
                          ><a :href="item.linkAddress"
                            ><img
                              :src="ImgUrl + item.PictureFilename"
                              style="width: 100%" /></a
                        ></el-col>
                        <div class="clearfix"></div>
                      </el-row>
                    </div>
                    <div class="pic_link" v-if="linktext.length > 0">
                      <div class="advice_text">文字链接</div>
                      <el-row :gutter="25" class="row ten">
                        <el-col
                          class="linkpic text-center"
                          v-for="(item, index) in linktext"
                          :key="index"
                          :sm="24"
                          :md="12"
                          :lg="6"
                          :xl="6"
                          :title="item.Tips"
                          ><a :href="item.linkAddress">{{
                            item.LinkName
                          }}</a></el-col
                        >
                        <div class="clearfix"></div>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsNewsBlockControl from '../components/DocumentsNewsBlockControl/DocumentsNewsBlockControl'
export default {
  data() {
    return {
      Ishtml: true,
      linktext: [],
      linkpic: [],
    }
  },
  components: {
    DocumentsNewsBlockControl,
  },
  mounted() {
    this.postFirend()
  },
  methods: {
    postFirend() {
      let params = [
        {
          Type: 2,
          Size: 0,
        },
        {
          Type: 1,
          Size: 0,
        },
      ]

      this.$store
        .dispatch('_postFirend', params)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.linktext = res.data.Data.Text
            this.linkpic = res.data.Data.Img
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style scoped></style>
